import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ProjectProposalForm.css';
import './ProjectProposalAddlSubItem.css';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { newAddlItem } from 'components/admin/projects/details/project-proposal/store/actions';
import Input from 'components/shared/input/Input';
import numeral from 'numeral';
import Number from 'components/shared/text/Number';
import settingsPng from 'images/settings.png';
import OutsideAlerter from 'components/shared/OutsideAlerter';
import ProjectProposalAddlSubItem from 'components/admin/projects/details/project-proposal/ProjectProposalAddlSubItem';

class ProjectProposalAddlItem extends Component {
  static propTypes = {
    itemKey: PropTypes.string.isRequired,
    itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    itemTotalCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    itemTitle: PropTypes.string.isRequired,
    itemRatio: PropTypes.number,
    subItems: PropTypes.shape({}).isRequired,
    readOnly: PropTypes.bool.isRequired,
    onRatioChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    itemValue: '',
    itemTotalCost: '',
    itemRatio: null,
    onRatioChange: null,
  };

  constructor(props) {
    super(props);

    this.state = { addlItemMenu: false };
  }

  handleAddlItemChange = (value) => {
    const { itemKey, itemRatio, onChange, onRatioChange } = this.props;
    onChange(itemKey, value);
    itemRatio !== null && onRatioChange && onRatioChange(itemKey, null, value);
  };

  handleRatioChange = (value) => {
    const { itemKey, onRatioChange } = this.props;
    onRatioChange && onRatioChange(itemKey, value);
  };

  handleAddSubcategory = () => {
    const { itemKey, subItems, dispatch } = this.props;
    dispatch(newAddlItem(itemKey, subItems));
    this.handleMenuToggle();
  };

  handleMenuToggle = () => {
    const { addlItemMenu } = this.state;
    this.setState({ addlItemMenu: !addlItemMenu });
  };

  renderSettings = () => {
    const { addlItemMenu } = this.state;
    return (
      <div className="proposal-item-settings">
        <div className="settings-icon" onClick={this.handleMenuToggle}>
          <img src={settingsPng} alt="settings" />
        </div>
        {addlItemMenu && (
          <OutsideAlerter onClickOutside={this.handleMenuToggle}>
            <div className="settings-menu">
              <div
                className="settings-menu-item"
                onClick={this.handleAddSubcategory}
              >
                Add Subcategory
              </div>
            </div>
          </OutsideAlerter>
        )}
      </div>
    );
  };

  activeSubItemsKeys = () => {
    const { subItems } = this.props;
    return Object.keys(subItems || {}).filter(
      (subItemKey) => !subItems[subItemKey].delete
    );
  };

  render() {
    const {
      itemKey,
      itemValue,
      itemTitle,
      itemTotalCost,
      itemRatio,
      subItems,
      currentProject,
      readOnly,
    } = this.props;
    const activeSubItemsKeys = this.activeSubItemsKeys();
    const hasSubItems = activeSubItemsKeys.length > 0;
    const lastSubItemKey = activeSubItemsKeys[activeSubItemsKeys.length - 1];
    return (
      <React.Fragment>
        {hasSubItems && (
          <tr>
            <td>{!readOnly && this.renderSettings()}</td>
            <td />
            <td>{itemTitle}</td>
            <td>
              <Number value={itemTotalCost || ''} format="$ 0,0" />
            </td>
            <td>
              <Number
                value={
                  itemTotalCost ? itemTotalCost / currentProject.sq_footage : ''
                }
                format="$ 0,0.[00]"
              />
            </td>
            <td />
          </tr>
        )}
        <tr className={hasSubItems ? 'project-proposal-addl-sub-item' : ''}>
          <td>{!readOnly && !hasSubItems && this.renderSettings()}</td>
          <td />
          <td>
            {itemTitle}
            {hasSubItems ? ' - Original Cost' : ''}
          </td>
          <td>
            {readOnly ? (
              <Number value={itemValue || ''} format="$ 0,0" />
            ) : (
              <Input
                placeholder="$0"
                value={itemValue ? numeral(itemValue).format('$ 0,0') : ''}
                onChange={(value) =>
                  this.handleAddlItemChange(numeral(value).value())
                }
              />
            )}
          </td>
          <td>
            <Number
              value={itemValue ? itemValue / currentProject.sq_footage : ''}
              format="$ 0,0.[00]"
            />
          </td>
          <td>
            {itemRatio !== null &&
              (readOnly ? (
                <Number value={itemRatio || ''} format="0 %" />
              ) : (
                <div className="addl-item-ratio">
                  <Input
                    placeholder="0"
                    value={
                      itemRatio ? numeral(itemRatio * 100).format('0') : ''
                    }
                    onChange={(value) =>
                      this.handleRatioChange(numeral(value / 100).value())
                    }
                  />
                  %
                </div>
              ))}
          </td>
        </tr>
        {activeSubItemsKeys.map((subItemKey) => {
          const subItem = subItems[subItemKey];
          return (
            <ProjectProposalAddlSubItem
              key={subItemKey}
              itemKey={itemKey}
              subItemKey={subItemKey}
              subItem={subItem}
              isLastSubItem={subItemKey === lastSubItemKey}
              readOnly={readOnly}
            />
          );
        })}
      </React.Fragment>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
  };
})(ProjectProposalAddlItem);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-proposal/ProjectProposalAddlItem.js